// @flow
import type { Action } from "../types"
import type { CompareCustomData } from "../types/compare_custom"

const compare_custom = (state: CompareCustomData = {}, action: Action): CompareCustomData => {
    switch (action.type) {
        case "SET_ATTRIBUTE_COMPARE":
            return {
                ...state,
                attribute_compare: action.payload,
            }
        case "IS_INSTALL_APP":
            return {
                ...state,
                isInstall: action.payload,
            }
        case "IS_INSTALL_AT_APP":
            return {
                ...state,
                isInstallAT: action.payload,
            }
        case "SET_COMPARE_OPTIONS":
            return {
                ...state,
                compare_options: action.payload,
            }
        default:
            return state
    }
}

export default compare_custom
